import {combineReducers, Reducer} from 'redux'
import clienteReducer from "./clienteReducer";
import {IRecoleccion} from "../types/recoleccionActionTypes";
import sucursalReducer from "./sucursalReducer";
import {recoleccionOrigenReducer, recoleccionDestinoReducer} from "./recoleccionReducer";
import {solicitudCopiaReducer, solicitudReducer} from "./solicitudReducer";
import {EmbalajeState} from "../types/embalajeActionTypes";
import embalajeReducer from "./embalajeReducer";
import {mercanciaReducer} from "./mercanciaReducer";
import {ICategoriaServicio} from "../types/servicioAdicionalType";
import {categoriaServicioReducer, servicioAdicionalReducer} from "./servicioAdicionalReducer";
import {usuarioReducer} from "./usuarioReducer";
import {ServicioAdicional} from "../../entities/catalogos/ServicioAdicional";
import {Sucursal} from "../../entities/catalogos/Sucursal";
import tipoEnvioReducer from "./tipoEnvioReducer";
import {ITipoEnvio} from "../../entities/catalogos/ITipoEnvio";
import {IParametro} from "../types/parametroActionTypes";
import parametroReducer from "./parametroReducer";
import tipoSeguroObservacionReducer from "./tipoSeguroObservacionReducer";
import {ICatalogo} from "../../entities/catalogos/ICatalogo";
import paisReducer from "./paisReducer";
import {IUsuario} from "../../entities/catalogos/IUsuario";
import {ICliente} from "../../entities/catalogos/ICliente";
import {Solicitud} from "../../entities/solicitudes/Solicitud";
import {Mercancia} from "../../entities/solicitudes/Mercancia";
import { ayudaReducer } from './ayudaReducer';
import { MercanciaDatosComplementarios } from '../../entities/solicitudes/MercanciaDatosComplementarios';
import { mercanciaDatosComplementariosReducer } from './mercanciaDatosComplementariosReducer';
import { ClaveUnidadState } from '../types/claveUnidadActionTypes';
import { ClaveProductoState } from '../types/claveProductoActionTypes';
import { ClaveFraccionArancelariaState } from '../types/claveFraccionArancelariaActionTypes';
import claveUnidadReducer from './claveUnidadReducer';
import claveProductoReducer from './claveProductoReducer';
import claveFraccionArancelariaReducer from './claveFraccionArancelariaReducer';
import { IIdioma } from '../../entities/catalogos/IIdioma';
import { idiomaReducer } from './idiomaReducer';
import diasFestivosReducer from './diasFestivosReducer';
import sucursalManyReducer from './sucursalManyReducer';
import { CruceInternacional } from '../../entities/catalogos/CruceInternacional';
import cruceInternacionalReducer from './cruceInternacionalReducer';

export interface ApplicationState {
    cliente: ICliente;
    recoleccionOrigen: IRecoleccion;
    recoleccionDestino: IRecoleccion;
    sucursales: Sucursal[] | any;
    solicitud: Solicitud;
    solicitudCopia: Solicitud;
    embalajes: EmbalajeState[] | any;
    mercancias: Mercancia[];
    mercanciasDatosComplementarios: MercanciaDatosComplementarios[];
    categoriasServicios: ICategoriaServicio[] | any;
    serviciosAdicionales: ServicioAdicional[] | any;
    usuario: IUsuario;
    tiposEnvio: ITipoEnvio[] | any;
    parametros: IParametro[] | any;
    tiposSeguroObservacion: ICatalogo[] | any;
    paises: ICatalogo[] | any;
    ayuda: any;
    idioma: IIdioma;
    clavesUnidad: ClaveUnidadState[] | any;
    clavesProducto: ClaveProductoState[] | any;
    clavesFraccionArancelaria: ClaveFraccionArancelariaState[] | any; 
    diasFestivos: ICatalogo[] | any;
    sucursalesMany: Sucursal[] | any;
    crucesInternacionales: CruceInternacional[] | any;
}

export const rootReducer: Reducer<ApplicationState> = combineReducers<ApplicationState>({
    cliente: clienteReducer,
    recoleccionOrigen: recoleccionOrigenReducer,
    recoleccionDestino: recoleccionDestinoReducer,
    sucursales: sucursalReducer,
    solicitud: solicitudReducer,
    solicitudCopia: solicitudCopiaReducer,
    embalajes: embalajeReducer,
    mercancias: mercanciaReducer,
    mercanciasDatosComplementarios: mercanciaDatosComplementariosReducer,
    categoriasServicios: categoriaServicioReducer,
    serviciosAdicionales: servicioAdicionalReducer,
    usuario: usuarioReducer,
    tiposEnvio: tipoEnvioReducer,
    parametros: parametroReducer,
    tiposSeguroObservacion: tipoSeguroObservacionReducer,
    paises: paisReducer,
    ayuda: ayudaReducer,
    idioma: idiomaReducer,
    clavesUnidad: claveUnidadReducer,
    clavesProducto: claveProductoReducer,
    clavesFraccionArancelaria: claveFraccionArancelariaReducer,
    crucesInternacionales: cruceInternacionalReducer, 
    diasFestivos: diasFestivosReducer,
    sucursalesMany: sucursalManyReducer,  // Agregar esto al final para que se cargue después de las demás reducers.
});

